import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Input, Button, Popconfirm, DatePicker, Select } from "antd";
import { DeleteOutlined, UserAddOutlined } from '@ant-design/icons';
import moment from 'moment';

const { Option } = Select;

class ConsultantOnline extends Component {
    state = {
        items: [{
            key: 0,
            user_id: null,
            consultant_date: "",
            note: ""
        }],
        count: 0
    }

    componentDidMount() {
        if (this.props.currentItem) {
            var items = this.props.currentItem.map((item, index) => {
                return {
                    key: index + 1,
                    user_id: item.consultant_user_id,
                    consultant_date: item.consultant_date ? moment(item.consultant_date, 'YYYY-MM-DD HH:mm') : "",
                    note: item.note
                }
            });
            this.setState({ items: items, count: items.length }, () => {
                this.getItems(this.state.items);
            });
        }
    }

    onAdd() {
        let index = this.state.count + 1;
        let item = {
            key: index,
            user_id: null,
            consultant_date: "",
            note: ""
        }

        this.setState({
            items: [
                ...this.state.items,
                item
            ],
            count: index
        })
    }

    onDelete(key) {
        let items = this.state.items.filter(item => {
            return item.key != key;
        });

        this.setState({
            items: items
        })
    }

    onChangeItem(name, value, itemKey) {
        let items = [...this.state.items];
        let index = items.findIndex(item => item.key == itemKey);
        let currentItem = items[index];
        currentItem[name] = value;
        items[index] = currentItem;
        this.setState({ items: items });
    }

    getItems() {
        this.props.getItems(this.state.items);
    }

    render() {
        var { items } = this.state;
        var { config } = this.props;
        //console.log("item: ", items)
        var columns = [
            {
                title: "Nhân viên",
                dataIndex: "user_id",
                width: "30%",
                render: (text, record) => {
                    return (
                        <Select
                            style={{ width: '100%' }}
                            placeholder="Chọn nhân viên"
                            optionLabelProp="label"
                            allowClear={true}
                            showSearch={true}
                            defaultValue={text}
                            onChange={(value) => this.onChangeItem('user_id', value, record.key)}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {
                                config && config?.users ? (
                                    <>
                                        {
                                            config?.users.map((item) => {
                                                return (
                                                    <Option key={item.user_id} value={item.user_id} label={item.display_name}>{item.display_name}</Option>
                                                )
                                            })
                                        }
                                    </>
                                ) : null
                            }
                        </Select>
                    )
                }
            },
            {
                title: "Thời điểm tư vấn",
                dataIndex: "consultant_date",
                width: "25%",
                render: (text, record) => {
                    return (
                        <DatePicker
                            value={text}
                            name="consultant_date"
                            style={{ width: '100%' }}
                            onChange={(value) => this.onChangeItem("consultant_date", value, record.key)}
                            showTime={{ format: 'HH:mm' }}
                            format="DD/MM/YYYY HH:mm"
                        />
                    )
                }
            },
            {
                title: "Kết quả tư vấn",
                dataIndex: "note",
                width: "40%",
                render: (text, record) => {
                    return (
                        <Input
                            value={text}
                            name="note"
                            onChange={(e) => this.onChangeItem(e.target.name, e.target.value, record.key)}
                        />
                    )
                }
            },
            {
                title: "#",
                align: "center",
                render: (text, record) => {
                    return (
                        <Popconfirm
                            title="Xóa dòng này?"
                            onConfirm={() => this.onDelete(record.key)}
                            placement="topLeft"
                        >
                            <DeleteOutlined className='item-action-btn-remove' />
                        </Popconfirm>
                    )
                }
            }
        ];

        return (
            <div className='no-border-buttom-table w-100' onMouseOut={() => this.getItems()}>
                <Button type="dashed" size='small' onClick={() => this.onAdd()} icon={<UserAddOutlined />}>Thêm nhân viên tư vấn online</Button>
                <Table
                    className='mt-2'
                    size='small'
                    rowKey='key'
                    tableLayout="auto"
                    columns={columns}
                    dataSource={items}
                    pagination={false}
                    locale={{ emptyText: "Chưa có dữ liệu" }}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        config: state.config
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultantOnline);